const cmsApiUrl = import.meta.env.VITE_CMS_API_URL;
const cmsUrl = import.meta.env.VITE_CMS_URL;

export const cmsApiConfig = {
    url: cmsApiUrl,
    baseUrl: cmsUrl
}